<template>
  <div class="mobile_container">
    <div id="allmap" style="width: 100%;height: 12.94rem;"></div>
  </div>
</template>

<script>
  import config from '@/config.js'

  export default {
    name: 'index',
    components: {},
    data() {
      return {
      }
    },
    mounted () {
      // this.mpInit()
    },
    methods: {
      mpInit() {
        var map = new BMap.Map("allmap");            // 创建Map实例

        //根据浏览器获取当前经纬度
        var lng
        var lat
        var geolocation = new BMap.Geolocation()
        geolocation.getCurrentPosition(function(r){
          if(this.getStatus() == BMAP_STATUS_SUCCESS){
            var mk = new BMap.Marker(r.point)
            map.addOverlay(mk)
            map.panTo(r.point)
            lng = r.point.lng
            lat = r.point.lat
          }
          else {
            alert('failed'+this.getStatus())
          }
        })

        var point = new BMap.Point(lng, lat); // 创建点坐标
        map.centerAndZoom(point, 15);

        var top_left_control = new BMap.ScaleControl({anchor: BMAP_ANCHOR_TOP_LEFT});// 左上角，添加比例尺
        var top_left_navigation = new BMap.NavigationControl();  //左上角，添加默认缩放平移控件
        var top_right_navigation = new BMap.NavigationControl({
          anchor: BMAP_ANCHOR_TOP_RIGHT,
          type: BMAP_NAVIGATION_CONTROL_SMALL
        }); //右上角，仅包含平移和缩放按钮
        /*缩放控件type有四种类型:
          BMAP_NAVIGATION_CONTROL_SMALL：仅包含平移和缩放按钮；BMAP_NAVIGATION_CONTROL_PAN:仅包含平移按钮；BMAP_NAVIGATION_CONTROL_ZOOM：仅包含缩放按钮*/
        map.addControl(top_left_control);
        map.addControl(top_left_navigation);
        // map.addControl(top_right_navigation);
      },
    }
  }
</script>


<style>

</style>



// WEBPACK FOOTER //
// src/components/mobile/map.vue